import DOMPurify from 'dompurify';
import { Fragment, memo } from 'react';
import * as dayjs from 'dayjs';
import RatingStars, { CustomStarRatings } from 'components/RatingStars';

const keyLabels = {
  question_bank: { colorLabel: 'primary', label: 'Question Bank' },
  ncert_solutions: { colorLabel: 'info', label: 'NCERT' },
  mock_test: { colorLabel: 'success', label: 'Mock Exams' },
  previous_year: { colorLabel: 'danger', label: 'Previous Years' },
};

function RatingHistory({ results = [] }) {
  return (
    <>
      {results?.length > 0 ? (
        <>
          <div className="container">
            {results?.map?.((r) => {
              return (
                <Fragment key={r._id}>
                  <div className="saved lessonWrap--border p-0 my-4">
                    <div className="row bgltgreen level1 p-2">
                      <div className="col-12">
                        <strong>{r.name}</strong>
                      </div>
                    </div>
                  </div>
                  <>
                    {r?.quizRatings?.length > 0 ? (
                      <>
                        {r?.quizRatings?.map?.((q) => {
                          return (
                            <Fragment key={q._id + r._id}>
                              <div className="row">
                                <div className="col-1 col-offset-1"></div>
                                <div className="col-10 my-4">
                                  <div className="lessonWrap__text">
                                    {/* <RatingStars
                                      starProps={{ readOnly: true }}
                                      value={q?.currentRating}
                                    /> */}
                                    <div className="d-flex align-items-center">
                                      <span>Current rating is </span>{' '}
                                      <CustomStarRatings value={q?.currentRating || 0} />
                                    </div>
                                    <span
                                      class={`badge badge-${
                                        keyLabels[q?.quiz?.quizCategory]?.colorLabel
                                      } badge-pill mx-4`}
                                      style={{ lineHeight: 'unset', height: 'fit-content' }}
                                    >
                                      {keyLabels[q?.quiz?.quizCategory]?.label}
                                    </span>
                                    <span>{q.quiz.name}</span>
                                  </div>
                                  <p
                                    className="my-4"
                                    dangerouslySetInnerHTML={{
                                      __html: DOMPurify.sanitize(q.question.title),
                                    }}
                                  ></p>
                                  {q?.ratingsHistory?.length > 0 ? (
                                    <>
                                      <div class="table-responsive app-l-tab-sub">
                                        <table class="table">
                                          <thead>
                                            <tr>
                                              <th scope="col">#</th>
                                              <th scope="col">Rating given by</th>
                                              <th scope="col">Rating given on</th>
                                              <th scope="col">Rating</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {q?.ratingsHistory?.map?.((rq, i) => {
                                              return (
                                                <tr key={rq._id}>
                                                  <th scope="row">{i + 1}</th>
                                                  <td>{rq?.ratedBy?.name}</td>
                                                  <td>
                                                    {dayjs(rq?.ratedOn).format('DD MMM YYYY')}
                                                  </td>
                                                  <td>
                                                    {/* <RatingStars
                                                      starProps={{ readOnly: true }}
                                                      value={rq?.rating}
                                                    /> */}
                                                    <CustomStarRatings value={rq?.rating || 0} />
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="text-center">No previous ratings given.</div>
                                  )}
                                </div>
                              </div>
                            </Fragment>
                          );
                        })}
                      </>
                    ) : (
                      <div className="text-center">No ratings given.</div>
                    )}
                  </>
                </Fragment>
              );
            })}
            <div></div>
          </div>
        </>
      ) : (
        <div className="text-center">No rating history found.</div>
      )}
    </>
  );
}

export default memo(RatingHistory);
